import CustomSingleValue from './CustomSingleValue';

export default CustomSingleValue;
